import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-reset-passeord',
  templateUrl: './reset-passeord.component.html',
  styleUrls: ['./reset-passeord.component.css']
})
export class ResetPasseordComponent implements OnInit {
  isShowEyesPsswrd = false;
  isShowEyesCnfrimPass = false;
  inputTypeNew = 'password';
  inputTypeConfrim = 'password';
  inputTypeOld = 'password'
  newPassword: any;
  confrimPassword: any;
  oldPassword: any
  isShowEyesOldPsswrd: any;

  errorObj:any = {};

  constructor(
    public router:Router,
    public api:ApiService,
    public swal: SweetAlert,
  ) { }

  ngOnInit(): void {

  }
  viewPassword(val) {
    console.log(val);
    if (val == 'new') {
      this.isShowEyesPsswrd = !this.isShowEyesPsswrd;
      if (this.isShowEyesPsswrd) { this.inputTypeNew = 'text'; } else { this.inputTypeNew = 'password'; }
    }
    if (val == 'confrim') {

      this.isShowEyesCnfrimPass = !this.isShowEyesCnfrimPass;
      if (this.isShowEyesCnfrimPass) { this.inputTypeConfrim = 'text'; } else { this.inputTypeConfrim = 'password'; }
      console.log(this.isShowEyesCnfrimPass, this.inputTypeConfrim);
    }
    if (val == 'old') {
      this.isShowEyesOldPsswrd = !this.isShowEyesOldPsswrd;
      if (this.isShowEyesOldPsswrd) { this.inputTypeOld = 'text'; } else { this.inputTypeOld = 'password'; }
    }
  }

  passwordSubmit() {

    if(this.oldPassword==undefined || this.oldPassword==null) this.errorObj['old'] = 'Current password is required';
    if(this.newPassword==undefined || this.newPassword==null) this.errorObj['new'] = 'New password is required';
    if(this.confrimPassword==undefined || this.confrimPassword==null) this.errorObj['confirm'] = 'Confirm password is required';

    if (this.newPassword && this.confrimPassword) {

      this.errorObj['new'] = undefined;
      this.errorObj['confirm'] = undefined;

      if(this.newPassword == this.confrimPassword){

        let obj = {
          oldPassword : this.oldPassword,
          newPassword : this.newPassword,
          confirmPassword : this.confrimPassword,
        };

        this.api.changePassword(obj).then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            setTimeout(()=>{
              this.router.navigate(['organization/transport-manager/login']);
            },2500)
          }else {
            this.swal.swalFunction('error', res.status, res.message, 2000);
          }
          }).catch((err: any) => {
          console.log(err);
        });

      }
      else{
        this.errorObj['confirm'] = 'Please make sure your passwords match';
      }
    }
  }
 enterToPassWord(e) { }
}
